import { render, staticRenderFns } from "./offerhelp.vue?vue&type=template&id=01bd3185&"
import script from "./offerhelp.vue?vue&type=script&lang=js&"
export * from "./offerhelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bd3185')) {
      api.createRecord('01bd3185', component.options)
    } else {
      api.reload('01bd3185', component.options)
    }
    module.hot.accept("./offerhelp.vue?vue&type=template&id=01bd3185&", function () {
      api.rerender('01bd3185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mQHwZCKPj5nm/JS/comp/offerhelp.vue"
export default component.exports